import { style } from "@vanilla-extract/css";

export const logo = style({
  display: "block",
  objectFit: "contain",
  width: "4.6rem",
  maxHeight: "2rem",
});
